import { BackButton } from '../../BackButton/BackButton';
import { useCanGoBack } from '../hooks/useCanGoBack';
import { BannerSlotKeys } from '../types';
import { Slot } from './Slot';

const Navigation = () => {
  const canGoBack = useCanGoBack();

  if (!canGoBack) return null;

  return (
    <Slot id={BannerSlotKeys.Navigation}>
      <BackButton />
    </Slot>
  );
};

export default Navigation;
